import { formatTime } from 'utils/FormatDateTime'

export const formatOpenOrClosed = (hours, timeZone) => {
  {
    const apiTimeZoneOffset = timeZone == 'America/Detroit' ? 240 : 300,
      browserDate = new Date(),
      timeZoneOffset = apiTimeZoneOffset - browserDate.getTimezoneOffset(),
      timeElapsed = Date.now(),
      today = new Date(timeElapsed - timeZoneOffset * 60000),
      day = today.toString().split(' ')[0]

    let afterHours,
      open,
      dayMatch = false,
      classString = 'closed',
      openOrClosedString = 'Closed',
      timeFormatString,
      formattedTimeString = ''

    hours.map((h, index) => {
      if (h.openDay.slice(0, 3) === day) {
        dayMatch = true
        const dateToday =
            today.getMonth() +
            1 +
            '/' +
            today.getDate() +
            '/' +
            today.getFullYear(),
          openTime = new Date(dateToday + ' ' + h.openTime),
          closeTime = new Date(dateToday + ' ' + h.closeTime),
          nextOpen = index === hours.length - 1 ? hours[0] : hours[index + 1],
          openAllDay = h.openTime == '00:00' && h.closeTime == '24:00'

        if (Date.parse(today) > Date.parse(openTime)) {
          if (Date.parse(today) < Date.parse(closeTime)) {
            open = true
          } else {
            afterHours = true
          }
        }

        classString = open ? 'open' : 'closed'
        openOrClosedString = open ? 'Open Now' : 'Closed'
        timeFormatString =
          open && !openAllDay
            ? `Closes at ${formatTime(h.closeTime)}`
            : afterHours
              ? `Opens on ${nextOpen.openDay} at ${formatTime(
                  nextOpen.openTime
                )}`
              : !open
                ? `Opens at ${formatTime(h.openTime)}`
                : ''
      }
    })

    if (!dayMatch) {
      timeFormatString = `Opens on ${hours[0].openDay} at ${formatTime(
        hours[0].openTime
      )}`
    }

    formattedTimeString = `<div><span class="open-closed ${classString}">${openOrClosedString}</span>${timeFormatString}</div>`

    return formattedTimeString
  }
}
